<template>
  <iColumn
    v-if="!commentsFolded"
    :id="commentWidgetId"
    :width="myWidth"
    data-test="comment-input"
  >
    <StoryCommentBox
      ref="box"
      :story-id="storyEntityId"
      :preview="editMode"
      :disabled="showsSampleComments"
      :input-style-overrides="inputStyleOverrides"
    />
  </iColumn>
</template>
<script>
import {
  CommentsWidgetElementMixin,
} from "%/dynamic-component-editor/standard-elements/comments-widget/comments-widget-element-mixin";
import StoryCommentBox from "%/dynamic-component-editor/components/story-comments/StoryCommentBox.vue";
import { uniqueId } from "lodash";
import BackgroundColor from "%/dynamic-component-editor/options/background-color";
import FontColor from "%/dynamic-component-editor/options/font-color";
import BorderColor from "%/dynamic-component-editor/options/border-color";
import LayoutWidth from "%/dynamic-component-editor/options/layout-width";
import { openStoryCommentsOverlay } from "%/dynamic-component-editor/components/story-comments/mount-story-comments-overlay";

export default {
  name: "CommentInput",
  components: { StoryCommentBox },
  mixins: [CommentsWidgetElementMixin],
  elementPanelSettings: {
    displayName: "Comment Input",
    displayIcon: "text",
    elementGroup: "commentWidgetElements",
    elementType: "element",
  },
  options: [
    new LayoutWidth({ default: "fill" }),
    new BackgroundColor({
      "default": {
        "value": "subtle",
        "source": "theme.background",
      },
    }),
    new FontColor({
      "default": {
        "value": "standard",
        "source": "theme.font",
      },
    }),
    new BorderColor({
      "default": {
        "value": "light",
        "source": "theme.border",
      },
    }),
  ],
  data() {
    return {
      commentWidgetId: uniqueId("comment-widget"),
      unregisterCommentInput: null,
    };
  },
  computed: {
    inputStyleOverrides() {
      return {
        fontColor: this.getOptionValue(FontColor),
        backgroundColor: this.getOptionValue(BackgroundColor),
        borderColor: this.getOptionValue(BorderColor),
      };
    },
    myWidth() {
      return this.getOptionValue(LayoutWidth);
    },
  },
  mounted() {
    if (this.showsSampleComments) {
      return;
    }
    this.unregisterCommentInput = this.storyComments.registerCommentInput(this.storyEntityId, {
      submit: () => this.$refs.box?.submit() ?? Promise.resolve(false),
      reveal: () => this.reveal(),
      clear: () => this.$refs.box?.clear(),
    });
    if (!this.inFeedRow && new URLSearchParams(window.location.search).has("comment")) {
      this.reveal();
    }
  },
  beforeUnmount() {
    this.unregisterCommentInput?.();
  },
  methods: {
    reveal() {
      if (this.commentsFolded) {
        openStoryCommentsOverlay(this.storyEntityId, this.$.appContext);
        return;
      }
      this.$nextTick(() => {
        this.$el.scrollIntoView?.({ behavior: "smooth", block: "center" });
        this.$refs.box?.focus();
      });
    },
  },
};
</script>
